export default __webpack_public_path__ + "img/support-tickets.6f0f2f.svg";